export const newsTypes = ["全部", "公司新闻", "行业动态", "媒体报道", "活动公告"];
export const newsTimeRanges = ["全部时间", "近一周", "近一月", "近半年"];

export const newsList = [
  {
    id: "n1",
    title: "想要XX 发布新一代品牌服务框架，面向伙伴开放核心能力",
    type: "公司新闻",
    date: "2026-10-08",
    source: "想要XX 官方发布",
    author: "新闻中心",
    tags: ["品牌服务", "开放合作"],
    cover:
      "https://readdy.ai/api/search-image?query=Modern%20minimalist%20stage%20with%20a%20large%20soft%20glowing%20panel%20in%20blue%20gray%20and%20an%20orange%20accent%20line%2C%20abstract%20technology%20conference%20atmosphere%2C%20clean%20editorial%20photography%20wide%20shot&width=1200&height=800&seq=news-framework-01&orientation=landscape",
    summary:
      "全新框架围绕「更开放、更一致、更易用」三个方向重构，合作伙伴可通过统一入口接入品牌核心能力，降低协作成本。",
    points: ["统一能力接入入口", "协作流程标准化", "面向伙伴逐步开放"],
    content: [
      {
        heading: "为什么要重构服务框架",
        paragraphs: [
          "随着合作范围扩大，原有框架在扩展性与一致性上面临挑战。此次重构的目标是让能力接入变得可预期、可复用。",
        ],
      },
      {
        heading: "对伙伴意味着什么",
        paragraphs: [
          "伙伴可以通过统一入口获取所需能力，并在同一套规范下完成对接，减少重复沟通与适配成本。",
        ],
      },
      {
        heading: "后续计划",
        paragraphs: [
          "新框架将分阶段开放，优先面向长期合作夥伴。详细接入说明将在资源查询页持续更新。",
        ],
      },
    ],
  },
  {
    id: "n2",
    title: "行业观察：品牌信息透明化正在成为新的信任基石",
    type: "行业动态",
    date: "2026-09-26",
    source: "行业观察网",
    author: "特约撰稿人",
    tags: ["行业趋势", "品牌信任"],
    cover:
      "https://readdy.ai/api/search-image?query=Abstract%20data%20visualization%20concept%20with%20translucent%20layered%20panels%20in%20blue%20gray%20and%20a%20single%20orange%20line%2C%20clean%20minimal%20corporate%20editorial%20graphic&width=1200&height=800&seq=news-transparency-01&orientation=landscape",
    summary:
      "越来越多的用户在选择品牌时，会主动查找公开信息。信息透明正在从「加分项」变为「基础项」，这也重塑了品牌官网的角色。",
    points: ["用户决策更依赖公开信息", "官网回归信息中枢", "透明化降低沟通成本"],
    content: [
      {
        heading: "用户行为的转变",
        paragraphs: [
          "用户在形成初步意向之后，会花更多时间检索品牌背景、发展历程与真实评价。",
        ],
      },
      {
        heading: "对品牌官网的新要求",
        paragraphs: [
          "官网不再只是展示页，而是需要承担信息整合与检索的功能，帮助用户快速找到答案。",
        ],
      },
      {
        heading: "我们的思考",
        paragraphs: [
          "想要XX 将品牌介绍与资源查询作为长期投入方向，希望通过更清晰的信息组织回应用户的检索习惯。",
        ],
      },
    ],
  },
  {
    id: "n3",
    title: "想要XX 亮相年度品牌体验展，现场发布三大主题展区",
    type: "活动公告",
    date: "2026-09-12",
    source: "想要XX 活动组",
    author: "活动运营",
    tags: ["线下活动", "品牌体验"],
    cover:
      "https://readdy.ai/api/search-image?query=Bright%20minimalist%20exhibition%20booth%20with%20three%20clean%20display%20zones%2C%20soft%20lighting%2C%20blue%20gray%20and%20orange%20accent%20panels%2C%20visitors%20in%20motion%20blur%2C%20editorial%20event%20photography&width=1200&height=800&seq=news-expo-01&orientation=landscape",
    summary:
      "展会现场设置品牌历史、产品体验与合作交流三大展区，吸引众多参观者驻足体验，现场互动氛围热烈。",
    points: ["三大主题展区", "现场互动体验", "面向公众开放"],
    content: [
      {
        heading: "展区一览",
        paragraphs: [
          "品牌历史展区以时间线形式呈现十二年成长脉络；产品体验区提供动手体验；合作交流区面向行业伙伴交流。",
        ],
      },
      {
        heading: "现场反馈",
        paragraphs: [
          "参观者普遍对品牌发展历程展区表现出浓厚兴趣，不少用户在现场完成了深度咨询。",
        ],
      },
      {
        heading: "后续安排",
        paragraphs: [
          "展会相关资料已整理至资源查询页，供未能到场的用户查阅。",
        ],
      },
    ],
  },
  {
    id: "n4",
    title: "媒体聚焦：想要XX 的长期主义产品观",
    type: "媒体报道",
    date: "2026-08-30",
    source: "数字营销周刊",
    author: "记者 林一",
    tags: ["媒体报道", "产品观"],
    cover:
      "https://readdy.ai/api/search-image?query=Editorial%20magazine%20spread%20concept%20with%20soft%20typography%20blocks%20and%20an%20orange%20accent%20bar%20on%20a%20light%20gray%20background%2C%20minimal%20blue%20gray%20tones%2C%20clean%20print%20design%20photography&width=1200&height=800&seq=news-media-01&orientation=landscape",
    summary:
      "在追求快速迭代的行业氛围里，想要XX 选择了更慢但更稳的节奏。本文复盘其长期主义产品观的形成与实践。",
    points: ["坚持长期价值", "克制地做加法", "以留存验证判断"],
    content: [
      {
        heading: "慢一点的底气",
        paragraphs: [
          "想要XX 更愿意在验证充分之后再放量，这种节奏在市场喧嚣时显得克制。",
        ],
      },
      {
        heading: "如何做减法",
        paragraphs: [
          "团队内部有一套明确的取舍标准：如果功能不能显著提升核心体验，就暂缓。",
        ],
      },
      {
        heading: "结果的印证",
        paragraphs: [
          "稳定的复购与推荐数据，让长期主义的坚持获得了现实回报。",
        ],
      },
    ],
  },
  {
    id: "n5",
    title: "想要XX 携手多家机构启动公共资源共建计划",
    type: "公司新闻",
    date: "2026-08-14",
    source: "想要XX 官方发布",
    author: "新闻中心",
    tags: ["合作计划", "公共资源"],
    cover:
      "https://readdy.ai/api/search-image?query=Team%20collaboration%20concept%20with%20hands%20joining%20over%20a%20light%20table%2C%20soft%20studio%20lighting%2C%20blue%20gray%20tones%20with%20a%20warm%20orange%20accent%2C%20editorial%20business%20photography&width=1200&height=800&seq=news-coop-01&orientation=landscape",
    summary:
      "该计划将联合多家行业机构共同建设公共资源库，向公众开放部分研究资料与实践案例，降低信息获取门槛。",
    points: ["多方联合共建", "面向公众开放", "持续更新内容"],
    content: [
      {
        heading: "计划目标",
        paragraphs: [
          "通过共建方式汇集优质公共资源，让更多用户能够便捷获取可信、实用的信息。",
        ],
      },
      {
        heading: "参与方式",
        paragraphs: [
          "具备相关资源的机构可通过联系我们页面提交合作意向，审核通过后进入共建流程。",
        ],
      },
      {
        heading: "进展安排",
        paragraphs: [
          "首批资源预计在年内上线，后续将按季度更新。",
        ],
      },
    ],
  },
  {
    id: "n6",
    title: "行业动态：资源检索正在走向「组合筛选」时代",
    type: "行业动态",
    date: "2026-07-22",
    source: "行业观察网",
    author: "特约撰稿人",
    tags: ["行业趋势", "检索体验"],
    cover:
      "https://readdy.ai/api/search-image?query=Minimal%20abstract%20grid%20of%20filter%20chips%20and%20cards%20in%20blue%20gray%20and%20orange%2C%20clean%20ui%20concept%20illustration%20on%20light%20gray%20background%2C%20editorial%20graphic&width=1200&height=800&seq=news-filter-01&orientation=landscape",
    summary:
      "单一关键词搜索已难以满足复杂需求，多条件组合筛选逐渐成为资源类平台的标准配置。",
    points: ["单一搜索的局限", "组合筛选的价值", "筛选即导航"],
    content: [
      {
        heading: "为什么需要组合筛选",
        paragraphs: [
          "当资源数量增长，用户往往需要同时满足多个条件，单一搜索框难以精准定位。",
        ],
      },
      {
        heading: "筛选即导航",
        paragraphs: [
          "清晰的筛选维度本身也是一种导航，帮助用户理解内容结构。",
        ],
      },
      {
        heading: "我们的实践",
        paragraphs: [
          "资源查询页支持类型与领域组合筛选，并保留关键词检索作为补充。",
        ],
      },
    ],
  },
  {
    id: "n7",
    title: "想要XX 品牌开放日：走进内容与设计团队",
    type: "活动公告",
    date: "2026-07-08",
    source: "想要XX 活动组",
    author: "活动运营",
    tags: ["开放日", "团队交流"],
    cover:
      "https://readdy.ai/api/search-image?query=Inviting%20open%20office%20space%20with%20whiteboards%20and%20soft%20natural%20light%2C%20people%20gathered%20casually%2C%20blue%20gray%20minimal%20decor%20with%20orange%20accents%2C%20editorial%20documentary%20photography&width=1200&height=800&seq=news-openday-01&orientation=landscape",
    summary:
      "开放日邀请公众走进想要XX，与内容与设计团队面对面交流，了解品牌内容是如何被生产出来的。",
    points: ["面对面交流", "了解内容生产", "面向公众报名"],
    content: [
      {
        heading: "活动亮点",
        paragraphs: [
          "参与者可以近距离了解内容策划、编辑与设计流程，并与团队成员直接交流。",
        ],
      },
      {
        heading: "报名方式",
        paragraphs: [
          "开放日采取预约制，具体场次信息通过官方渠道发布。",
        ],
      },
      {
        heading: "活动回响",
        paragraphs: [
          "到场用户反馈，开放日让品牌变得更有温度、更可信任。",
        ],
      },
    ],
  },
  {
    id: "n8",
    title: "媒体报道：一个品牌官网可以承担多少信任",
    type: "媒体报道",
    date: "2026-06-25",
    source: "品牌研究院",
    author: "研究员 赵然",
    tags: ["媒体报道", "官网价值"],
    cover:
      "https://readdy.ai/api/search-image?query=Abstract%20trust%20concept%20with%20layered%20rounded%20shapes%20in%20blue%20gray%20and%20a%20warm%20orange%20sphere%2C%20soft%20gradient%20light%2C%20clean%20minimal%20editorial%20illustration&width=1200&height=800&seq=news-trust-01&orientation=landscape",
    summary:
      "官网是品牌与用户之间最稳定的接触点。本文讨论在信息爆炸的环境下，一个结构清晰的官网能承担多少信任成本。",
    points: ["官网是稳定触点", "结构清晰即信任", "信息决定决策"],
    content: [
      {
        heading: "稳定触点的价值",
        paragraphs: [
          "相比瞬息万变的社交渠道，官网是品牌可以长期维护、稳定呈现的信息空间。",
        ],
      },
      {
        heading: "结构清晰带来信任",
        paragraphs: [
          "当用户能够顺畅找到所需信息，信任感会自然建立。",
        ],
      },
      {
        heading: "给品牌的建议",
        paragraphs: [
          "把官网当作信息中枢来经营，而不仅是营销门面。",
        ],
      },
    ],
  },
];